module.exports = __webpack_public_path__ + "img/020025.a0df4883.png";